import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivateChild,
} from '@angular/router';
import { Observable } from 'rxjs';
import { FeatureFlagService } from './feature-flag.service';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FeatureGuard implements CanActivate, CanActivateChild {
  constructor(
    private featureFlagService: FeatureFlagService,
    private router: Router,
  ) {}

  checkFeature(route: ActivatedRouteSnapshot): Observable<boolean> {
    const featureName = route.data['featureFlag'] as string;

    return this.featureFlagService.isFeatureEnabled(featureName).pipe(
      tap((isEnabled) => {
        if (!isEnabled) {
          this.router.navigate(['/']); // Redirect to landing page if feature is disabled
        }
      }),
      map((isEnabled) => isEnabled),
    );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.checkFeature(route);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.checkFeature(childRoute);
  }
}
